import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ModuleSubNav } from '@/components/ui/module-sub-nav/ModuleSubNav';
import { MobileBackBar } from '@/components/ui/mobile-back-bar';
import { MobileTabBar } from '@/components/ui/mobile-tab-bar';
import { useModuleConfig } from '@/hooks/useModuleConfig';
import { useRegisterModuleContext } from '@/hooks/useRegisterModuleContext';

export default function MainLayout() {
  const location = useLocation();
  const { currentModule, subNavTabs, mobileTabs, isFirstLevelRoute } = useModuleConfig();
  useRegisterModuleContext(currentModule, subNavTabs);

  return (
    <div className="flex flex-col flex-1 min-w-0 overflow-hidden bg-[var(--background-page-body)]">
      {subNavTabs.length > 0 && <ModuleSubNav tabs={subNavTabs} />}
      {/* Mobile back row — sits on the page background beneath the header
          rather than inside it, and outside <main> so it stays reachable
          without scrolling to the top of long pages. */}
      {!isFirstLevelRoute && <MobileBackBar fallbackHref={currentModule?.href ?? '/'} />}
      <main className="flex-1 overflow-y-auto px-4 py-4 md:px-10 md:py-8">
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname.split('/')[1] || 'root'}
            initial={{ x: '100%', opacity: 0.6 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: '100%', opacity: 0.6 }}
            transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
            className="h-full"
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>
      {isFirstLevelRoute && <MobileTabBar tabs={mobileTabs} />}
    </div>
  );
}
